






import {Component, Vue} from "vue-property-decorator";
import CompanyCard from "@/components/footer/CompanyCard.vue";
import {Card} from "@/types/landing/Card";
import company1 from "@/assets/images/company1.png";
import company2 from "@/assets/images/company2.png";
import company3 from "@/assets/images/company3.png";

@Component({
  components: {CompanyCard},
})
export default class FootBody extends Vue {
  cards: Card[] = [
    {
      imgSrc: company1,
      title: "香港商眾點數位行銷 ZoomIn Digital Marketing Co.",
      link: "http://www.inzoomin.com/",
    },
    {
      imgSrc: company2,
      title: "雲數位智能行銷有限公司 CloudAD",
      link: "https://cloudad.tech/",
    },
    {
      imgSrc: company3,
      title: "欣新網股份有限公司 HHG",
      link: "http://www.hhgalaxy.com.tw/",
    },
  ];
}
